module.exports = __webpack_public_path__ + "static/media/chaleco-3.c29b629e.png";